/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateCompositionsDetailMutationRequest, WebAppCreateCompositionsDetailMutationResponse, WebAppCreateCompositionsDetail401, WebAppCreateCompositionsDetail403 } from "../models/WebAppCreateCompositionsDetail";

export function getWebAppCreateCompositionsDetailUrl() {
  const res = { method: 'POST', url: `/web-app/v1/compositions` as const }
  return res
}

/**
 * @summary Create a composition
 * {@link /web-app/v1/compositions}
 */
export async function webAppCreateCompositionsDetail(data: WebAppCreateCompositionsDetailMutationRequest, config: Partial<RequestConfig<WebAppCreateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCreateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateCompositionsDetail401 | WebAppCreateCompositionsDetail403>, WebAppCreateCompositionsDetailMutationRequest>({ method : "POST", url : getWebAppCreateCompositionsDetailUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}